import Vue, { Component } from 'vue';
import { Component as ComponentDecorator } from 'vue-property-decorator';
import CVueInstance from './CVueInstance';

@ComponentDecorator({
  props: {
    backgroundText: String,
    backgroundColor: String,
    textColor: String,
    backgroundImageUrl: String,
    mainText: String,
    subText: String,
  },
})

export default class CubeReviewsBlock extends CVueInstance {
  get getId() {
    return `${this.GetMyId()}-reviews1`;
  }
  public mounted() {
    (window as any).$(`#${this.getId}`).slick({
      speed: 500,
      infinite: true,
      dots: true,
      arrows: false,
      // fade: true,
      // cssEase: 'linear'
    });
  }
}
